import { render, staticRenderFns } from "./createSerRoute.vue?vue&type=template&id=fcac385c&scoped=true&"
import script from "./createSerRoute.vue?vue&type=script&lang=js&"
export * from "./createSerRoute.vue?vue&type=script&lang=js&"
import style0 from "./createSerRoute.vue?vue&type=style&index=0&id=fcac385c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcac385c",
  null
  
)

export default component.exports